var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "proCard" },
    [
      _c(
        "van-panel",
        {
          attrs: {
            title: _vm.pro.orderCode ? "订单编号：" + _vm.pro.orderCode : ""
          }
        },
        [
          _c("div", { staticClass: "proCard-content" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "proimg" }, [
                _c("img", { attrs: { src: _vm.pro.productImg, alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.pro.productName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "price" }, [
                    _vm._v(_vm._s(_vm.pro.productPrice))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.pro.specificationValue))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "num" }, [
                    _vm._v("X" + _vm._s(_vm.pro.quantity))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sign" },
                  [
                    _c(
                      "van-tag",
                      {
                        staticClass: "pinkTag",
                        attrs: { round: "", color: "rgba(238,46,80,0.20)" }
                      },
                      [_vm._v(_vm._s(_vm.pro.productBusinessTypeStr))]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-tag",
                      { attrs: { round: "", color: _vm.tagColor } },
                      [_vm._v(_vm._s(_vm.pro.accountLvDesc))]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pro-sum" }, [
              _c("div", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.pro.createTime))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sum-price" }, [
                _vm._v(
                  "\n                    共" +
                    _vm._s(_vm.pro.quantity) +
                    "件商品 合计：¥" +
                    _vm._s(_vm.pro.productPaymentAmount) +
                    "\n                "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "headerBox",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.pro.orderCode ? "订单编号：" + _vm.pro.orderCode : ""
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _vm.pro.proceedsLv2 || _vm.pro.proceedsLv1
                ? _c("div", [
                    _vm._v(
                      "\n                赚" +
                        _vm._s(
                          _vm.pro.accountLvDesc === "一级账户"
                            ? _vm.pro.proceedsLv1
                            : _vm.pro.proceedsLv2
                        ) +
                        "元\n            "
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("div"),
            _vm._v(" "),
            _c("div", { staticClass: "from" }, [
              _c("p", [_vm._v("订单来源：")]),
              _vm._v(" "),
              _c("div", { staticClass: "img" }, [
                _c("img", { attrs: { src: _vm.pro.accountAvatar, alt: "" } })
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.pro.accountName))])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }